/**
 * Lead list/export visibility only.
 * `user_id` on leads = assignee. `created_by` = creator.
 * Non-admins see assigned OR created leads via visibility_user_id on API payloads.
 */

export function shouldApplyLeadUserVisibility(
  isAdmin: boolean,
  clientId: string | number | null | undefined
): boolean {
  if (isAdmin) {
    return false;
  }
  if (String(clientId ?? '') === '1') {
    return false;
  }
  return true;
}

export function applyLeadVisibilityUserId(
  payload: Record<string, any>,
  userId: string | number,
  isAdmin: boolean,
  clientId: string | number | null | undefined
): void {
  if (!shouldApplyLeadUserVisibility(isAdmin, clientId)) {
    return;
  }

  payload['visibility_user_id'] = userId;

  if (payload['where']?.['user_id'] !== undefined) {
    const { user_id: _removed, ...rest } = payload['where'];
    payload['where'] = rest;
  }
}

export function applyLeadVisibilityToExportPayload(
  payload: Record<string, any>,
  userId: string | number,
  isAdmin: boolean,
  clientId: string | number | null | undefined
): void {
  if (!shouldApplyLeadUserVisibility(isAdmin, clientId)) {
    return;
  }
  payload['visibility_user_id'] = userId;
  delete payload['user_id'];
}
